module.exports = __webpack_public_path__ + "img/grid_layout_2_2.94f28033.svg";